// extracted by mini-css-extract-plugin
export default {"link":"DsAnLvhg","img":"MxEVRxwN","headline":"M_smvnNF","_isLarge":"_oZMu65b"};